import React, { useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'antd';
import {
  Container
} from './styles';
import CreateDocTemplate from './CreateDocTemplate';
import MasterTemplate from './MasterTemplate';
import { withTranslation } from 'react-i18next';
import { CREATE_DOCUMENT_MODAL } from './translationValues';
import ComplexDocumentHistoryProvider from '../../context/complexDocumentContext';
import ComplexArtboardProvider from '../../context/complexArtboardContext';
import ComplexTextEditingProvider from '../../context/complexTextEditingContext';
import BusinessLogicProvider from '../../context/businessLogicContext';
import FontsProvider from '../../context/fontsContext';

const CreateTemplateModal = props => {
  const { t, visible, onCancel, onSucess, type, template = {}, modal = true, selectDesign = true, isEmailToDoc=false,
    categoryId = undefined, resourceGroupId = undefined, communicationId = undefined, isOpenDesign = false, autoCreateTemplate = false, firstLogin = false } = props;

  const [defaultTemplate, setDefaultTemplates] = useState(false);
  const [masterTemplate, setMasterTemplate] = useState({});

  const toggleMasterView = useCallback(() => {
    setDefaultTemplates(previousValue => {
      return !previousValue;
    });
  }, []);

  useEffect(() => {
    if (!visible) {
      setDefaultTemplates(false);
      setMasterTemplate({});
    }
  }, [visible]);

  const renderContents = () => {
    return (
      <>
        <CreateDocTemplate
          type={type}
          onSucess={onSucess}
          template={template}
          setDefaultTemplates={toggleMasterView}
          defaultTemplate={defaultTemplate}
          masterTemplate={masterTemplate}
          selectDesign={selectDesign}
          isEmailToDoc={isEmailToDoc}
          categoryId={categoryId}
          resourceGroupId={resourceGroupId}
          communicationId={communicationId}
          isOpenDesign={isOpenDesign}
          autoCreateTemplate={autoCreateTemplate}
        />
        {
          defaultTemplate &&
          (modal ?
            (<div style={{ position: "absolute", top: 0, left: '100%', background: "rgb(37,41 ,45)", width: "268px", height: "100%", borderRadius: '4px 4px 8px 8px' }}>
              <MasterTemplate setMasterTemplate={setMasterTemplate} />
            </div>)
          : document.getElementById('master-template-modal-body') ? ReactDOM.createPortal(
            (<div className={"master-template-section"} style={{ position: "absolute", background: "rgb(37,41 ,45)", width: "268px", height: "100%", borderRadius: '4px 4px 8px 8px' }}>
              <MasterTemplate setMasterTemplate={setMasterTemplate} />
            </div>),
            document.getElementById('master-template-modal-body')
          ) : <div />)
        }
      </>
    )
  };

  if (isOpenDesign) {
    return (
      <Container onKeyDown={e => e.stopPropagation()}>
            <Modal
              title={`${type === 'cloneTemplate' ? t(CREATE_DOCUMENT_MODAL.CLONE_TEMPLATE_TITLE.key, CREATE_DOCUMENT_MODAL.CLONE_TEMPLATE_TITLE.value) : t(CREATE_DOCUMENT_MODAL.CREATE_TEMPLATE_TITLE.key, CREATE_DOCUMENT_MODAL.CREATE_TEMPLATE_TITLE.value)}`}
              centered
              maskClosable={false}
              visible={visible}
              width="625px"
              onCancel={onCancel}
              footer={false}
              className="warning-modal"
              closable={!isOpenDesign}
              style={{ display: firstLogin && 'none' }}
              mask={!firstLogin}
            >
              {renderContents()}
            </Modal>
      </Container>
    );
  }

  return (
    <ComplexDocumentHistoryProvider>
      <ComplexArtboardProvider >
        <BusinessLogicProvider>
              <Container onKeyDown={e => e.stopPropagation()}>
                {modal ? (
                    <Modal
                      title={`${type === 'cloneTemplate' ? t(CREATE_DOCUMENT_MODAL.CLONE_TEMPLATE_TITLE.key, CREATE_DOCUMENT_MODAL.CLONE_TEMPLATE_TITLE.value) : t(CREATE_DOCUMENT_MODAL.CREATE_TEMPLATE_TITLE.key, CREATE_DOCUMENT_MODAL.CREATE_TEMPLATE_TITLE.value)}`}
                      centered
                      maskClosable={false}
                      visible={visible}
                      width="625px"
                      onCancel={onCancel}
                      footer={false}
                      className="warning-modal"
                      closable={!isOpenDesign}
                    >
                      {renderContents()}
                    </Modal>
                ) : renderContents()}
              </Container>
        </BusinessLogicProvider>
      </ComplexArtboardProvider>
    </ComplexDocumentHistoryProvider>

  );
};
export default withTranslation(["CREATE_DOCUMENT_MODAL"])(CreateTemplateModal);
